import React, { memo } from 'react'
import { ICarrierBillingLocation } from 'types/carrier'
import { DISPLAY } from 'constants/display'

interface ICarrierBillingLocationProps {
  carrierBillingLocation?: ICarrierBillingLocation
}

export const CarrierBillingAddress = memo<ICarrierBillingLocationProps>(
  ({ carrierBillingLocation }) => (
    <>
      <small>Carrier Billing Address</small>
      {carrierBillingLocation ? (
        <>
          <div>Address #1: {carrierBillingLocation.address}</div>
          <div>
            {carrierBillingLocation.addressLine2
              ? `Address #2: ${carrierBillingLocation.addressLine2}`
              : DISPLAY.empty}{' '}
          </div>
          <div>
            {carrierBillingLocation.city}, {carrierBillingLocation.stateCode}{' '}
            {carrierBillingLocation.zipcode}, {carrierBillingLocation.countryCode}
          </div>
          <div>Email: {carrierBillingLocation.contactEmail}</div>
          <div>Phone: {carrierBillingLocation.contactPhone}</div>
        </>
      ) : (
        <p>{DISPLAY.empty}</p>
      )}
    </>
  )
)
